
import { call, put, takeEvery } from 'redux-saga/effects'
import { types } from '../../types'
import { getCallReport } from '../apiRequests/callReportRequest'
import { getSettingsRequest, updateSettingsRequest } from '../apiRequests/settingsRequest'

function* handleGetSettings(action) {
  try {
    const response = yield call(getSettingsRequest,action.userId)
    yield put({
      type: types.GET_SETTINGS_SUCCESS,
      response: response,
    })
  } catch (error) {
    yield put({
      type: types.GET_SETTINGS_ERROR,
      error: error.response,
    })
  }
}


function* handleUpdateSettings(action) {
    try {
      const response = yield call(updateSettingsRequest,action.params)
      yield put({
        type: types.UPDATE_SETTINGS_SUCCESS,
        response: response,
      })
    } catch (error) {
      yield put({
        type: types.UPDATE_SETTINGS_ERROR,
        error: error.response,
      })
    }
  }

  

function* handleGetQueueStrategiesRequest() {
  try {
    const response = yield call(getSettingsRequest)
    
    yield put({
      type: types.GET_QUEUE_STRATEGIES_SUCCESS,
      action: response,
    })
  } catch (error) {
    yield put({
      type: types.GET_QUEUE_STRATEGIES_ERROR,
      error: error.response,
    })
  }
}

function* watcherSettingsSaga() {
    yield takeEvery(types.GET_SETTINGS_REQUEST, handleGetSettings)
    yield takeEvery(types.UPDATE_SETTINGS_REQUEST, handleUpdateSettings)
    yield takeEvery(types.GET_QUEUE_STRATEGIES_REQUEST, handleGetQueueStrategiesRequest)


  
  
  }
  
  export default watcherSettingsSaga